import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';

import SearchBar from 'Parts/search/SearchBarContainer';
// import PaginationTop from 'Parts/search/PaginationTop';
import ResultTable from 'Parts/search/ResultTable';

import { DEFAULT_PAGER } from 'Parts/search/searchUtils';
import { simpleColumn, actionColumn } from 'Parts/common/columnUtils';

import eventAdminRelatedCampaigns_en from './locales/EventAdminRelatedCampaigns_en.json';
import eventAdminRelatedCampaigns_fr from './locales/EventAdminRelatedCampaigns_fr.json';

class EventAdminRelatedCampaigns extends React.Component {
  constructor(props) {
    super(props);

    // props.campaigns.total = get(props, 'pagination.totalResults', 0);

    this.state = {
      pager: {
        ...DEFAULT_PAGER,
        total: get(props, 'pagination.totalResults', 0),
        current: get(props, 'pagination.pageNumber', 1),
        pageSize: get(props, 'pagination.pageResults', 10)
      }
    };

    i18next.addResourceBundle('en', 'EventAdminRelatedCampaigns', eventAdminRelatedCampaigns_en);
    i18next.addResourceBundle('fr', 'EventAdminRelatedCampaigns', eventAdminRelatedCampaigns_fr);
  }

  componentDidUpdate(prevProps) {
    // Update the pager with the new total
    let pager;

    if (
      this.props.pagination &&
      this.props.pagination.pageNumber !== prevProps.pagination.pageNumber
    ) {
      pager = {
        ...this.state.pager,
        total: get(props, 'pagination.totalResults', 0),
        current: get(props, 'pagination.pageNumber', 1),
        pageSize: get(props, 'pagination.pageResults', 10)
      };

      this.setState({ pager });
    }
  }

  componentWillUnmount() {
    // this.props.clearSearch();
  }

  handlePaginationChange = pager => {
    this.setState({ pager });
    const pagination = {
      pageResults: pager.pageSize,
      pageNumber: pager.current
    };
    // this.props.searchCampaigns(this.props.platformId, this.props.search, this.props.filters, pagination, { orderBy:'addedOn[desc]' }, true)
  };

  handleViewHandler = campaign => {
    // let currentUrl = this.props.location.pathname;
    // let campaignUrl = currentUrl.replace('list', campaign.id);
    // return this.props.history.push(campaignUrl);
  };

  handleSearch = filters => {
    const pagination = {
      pageResults: this.state.pager.pageSize
    };
    // this.props.searchCampaigns(this.props.platformId, filters.search, filters, pagination, {orderBy:'addedOn[desc]'}, true);
  };

  getPublicCampaignUrl = campaign => {
    // return this.props.location.pathname.replace('d/campaigns/list', campaign.alias);
  };

  render() {
    const { t } = this.props;
    const { pager } = this.state;

    return (
      <>
        <SearchBar
          title={t('related-campaigns-title')}
          placeholder={t('Search')}
          onSearch={this.handleSearch}
        />
        <div className="AdminList">
          {/* <PaginationTop
            totalLabel={total => t('campaignsTotal', { count: pagination.totalResults })}
            pager={pager}
            onChange={this.handlePaginationChange}
          /> */}
          <ResultTable
            dataSource={[]}
            pagination={pager}
            onChange={this.handlePaginationChange}
            showHeader={true}
            columns={[
              simpleColumn(t('Name'), 'name', null, true),
              simpleColumn(t('Status'), null, campaign => t(campaign.status), true),
              actionColumn(
                t('Public page'),
                null,
                () => {},
                campaign => {
                  const disabled =
                    campaign.statusId === 2 || campaign.statusId === 3 || campaign.statusId === 5
                      ? { disabled: true }
                      : {};
                  return (
                    <a
                      className="ant-btn ant-btn-circle"
                      href={this.getPublicCampaignUrl(campaign)}
                      target="_blank"
                      {...disabled}
                    >
                      <FontAwesomeIcon icon={['fal', 'external-link']} />
                    </a>
                  );
                }
              )
            ]}
          />
        </div>
      </>
    );
  }
}

export default translate('EventAdminRelatedCampaigns')(EventAdminRelatedCampaigns);
